<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 公章申请管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <div style="width:1200px">
                <el-form :model="query" ref="query" label-width="130px" inline="">
                    <el-form-item label="公司名称:" >
                        <el-input v-model="query.company_name" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-form-item label="公司地址:" >
                        <el-input v-model="query.company_address" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-form-item label="统一社会信用代码:" >
                        <el-input v-model="query.credit_code" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-form-item label="法人:" >
                        <el-input v-model="query.legal_person" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-form-item label="法人身份证:" >
                        <el-input v-model="query.identification" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                     <el-form-item label="联系电话:" >
                        <el-input v-model="query.contact" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-form-item label="公司类型:" >
                        <el-input v-model="query.address_type" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态:" >
                        <el-select v-model="query.status" placeholder="请输入" class="handle-input mr10" @change="inputSearch()">
                            <el-option v-for="item in statuslist" 
                            :label="item.label"
                            :key="item.id"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="申请时间" >
                        <el-date-picker class="data" type="date" placeholder="起始日期" v-model="query.start_time" style="width: 150px;padding-right:5px"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" @change="inputSearch()"></el-date-picker>
                        <span>-</span>
                        <el-date-picker  format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="data" type="date" placeholder="结束日期" v-model="query.end_time" style="width: 150px;padding-right:10px;padding-left:5px" @change="inputSearch()">
                        </el-date-picker>
                   </el-form-item>
                    <el-form-item  >
                         <el-button style="margin-left:30px" type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
                    <el-button type="primary"  @click="resetsearch()">重置</el-button>
                    </el-form-item>
                   
                </el-form>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                class="table1"
                ref="multipleTable"
                header-cell-class-name="table-header"
                :header-cell-style="{'text-align':'center'}"
            >
                <el-table-column prop="numbering" label="单号"   width="200" align="center"></el-table-column>
                <el-table-column prop="company_name" label="公司名称" width="250" align="center"></el-table-column>
                <el-table-column prop="legal_person" label="经办人" width="100" align="center"></el-table-column>
                <el-table-column prop="contact" label="联系电话" width="130" align="center"></el-table-column>
                <el-table-column prop="pay" label="订单金额"   width="80" align="center"></el-table-column>
                <el-table-column label="订单状态" align="center" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==1" style="color:rgb(242, 94, 67)">待付款</span>
                        <span v-else-if="scope.row.status==2" style="color:rgb(236, 160,70)">已受理</span>
                        <span v-else-if="scope.row.status==3" style="color:rgb(22,162,51)">待确认</span>
                        <span v-else-if="scope.row.status==4" style="color:rgb(22,162,251)">已完成</span>
                        <span  v-else-if="scope.row.status==5" style="color:red">申请退款</span>
                        <span v-else-if="scope.row.status==6" style="color:red">退款失败</span>
                        <span v-else-if="scope.row.status==7" style="color:red">已退款</span>
                    </template>
                </el-table-column>
                <el-table-column prop="application_time" label="申请时间"   width="160" align="center"></el-table-column>
                <el-table-column prop="collection_time" label="领取时间"   width="160" align="center"></el-table-column>
                <el-table-column prop="note" label="特殊备注"   width="120" align="center"></el-table-column>
                <el-table-column label="操作" width="120" align="left">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" content="修改订单价格" placement="top">
                            <img v-if="scope.row.status==1" class="iconPic" src="../../../assets/img/xiugaijiage.png" alt=""   @click="editPrice(scope.$index,scope.row)">
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
            <el-dialog title="价格修改" :visible.sync="editPriceVisiable" width="500px">
                <el-form ref="editPriceForm"  :rules="rules1" :model="editPriceForm" label-width="120px" >
                    <el-form-item prop="numbering" label="单号">
                        {{editPriceForm.numbering}}
                </el-form-item>
                <el-form-item prop="total" label="订单金额(元)">
                        {{editPriceForm.total}}
                </el-form-item>
                <el-form-item  label="修改价格(元)"  prop="price"  >
                    <el-input v-model="editPriceForm.price" ></el-input>
                    <div>Tips:当前商品最低价格{{count*editForm.total}}</div>
                </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="editPriceVisiable = false">取 消</el-button>
                    <el-button type="primary" @click="saveEditPrice()">确 定</el-button>
                </span>
            </el-dialog>
        </div>
         
    </div>
</template>

<script>


import { post } from '../../../api/request';
import { regionData } from 'element-china-area-data'
export default {
    name: 'basetable',
    data() {
         var price = (rule, value, callback) => {
            const reg = /^\d+.?\d{0,2}$/
            if (!value) {
                callback(new Error('请输入价格'))
            } else if (!Number(value)) {
                callback(new Error('请输入数字值'))
            } else {
                if (reg.test(value)) {
                callback()
                } else {
                callback(new Error('小数点后最多只能输入两位'))
                }
            }
        }
        return {
            rules1:{
                  price: [{ required: true, validator: price, trigger: 'blur' }]
            },
            editPriceForm:{
                numbering:"",
                total:"",
                price:"",
            },
            editForm:{},
            editPriceVisiable:false,
            id:'',
            printData:{
                company_name:'123'
                },
            number:'',
            needlist:[{
                label:'需要'
            },{
                label:'不需要'
            }],
           statuslist:[{
                label:'待付款',
                id:"1"
            },{
                label:'已受理',
                id:"2"
            },{
                label:'待确认',
                id:"3"
            },{
                label:'已完成',
                id:"4"
            },{
                label:'申请退款',
                id:"5"
            },{
                label:'退款失败',
                id:"6"
            },{
                label:'已退款',
                id:"7"
            }],
            cityindex:0,
            areaindex:0,
            options: regionData,
            sealTabeldata:[],
            companyid:'',//当前公司id
            //搜索数据
            tableData: [],
            query: {
                company_name: '',
                company_address: '',
                credit_code: '',
                legal_person: '',
                identification: '',
                contact: '',
                address_type: '',
                status: '',
                pageIndex:1,
                pageSize:8,
                start_time:'',
                end_time:''
            },
            count:1,
            pageTotal: 0,
            //添加数据
           
        };
    },
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.id =  sessionStorage.getItem('userid')
        this.getzhekou(sessionStorage.getItem('userid'))
        this.getData()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.id =  sessionStorage.getItem('userid')
        this.getData()
    },
    methods: {
        getzhekou(item){
            let formdata = new FormData()
            formdata.append("employ_id",item)
            post("backstage/Chaptertrear/seldiscount",formdata).then(res=>{
                if(res.data.data&&res.data.data>0)
                this.count = res.data.data/100
            })
        },
        editPrice(index,row){
            this.idx = index;
            this.editForm = Object.assign({}, row);
            this.editPriceForm.total = this.editForm.pay
            this.editPriceForm.numbering = this.editForm.numbering
            this.editPriceVisiable = true;
        },
        saveEditPrice(){
            if(this.editPriceForm.price<this.count*this.editForm.total){
                this.$message.error("价格不能小于给您的折扣价格")
            }
            else{
                this.$refs['editPriceForm'].validate((valid) => {
                if (valid) {
                    let formdata = new FormData()
                    formdata.append("numbering",this.editPriceForm.numbering)
                    formdata.append("pay",this.editPriceForm.price)
                    post("backstage/Chaptertrear/updrealpay",formdata).then(res=>{
                        if(res.data.msg =="修改成功")
                        {
                            this.$message.success("修改成功")
                            this.getData()
                            this.editPriceVisiable = false
                        }
                    })
                }
            })
            }
          
        },
        //重置搜索
        resetsearch(){
            this.query.company_name= '',
            this.query.company_address= '',
            this.query.redit_code= '',
            this.query.legal_person= '',
            this.query.identification= '',
            this.query.contact= '',
            this.query.address_type= '',
            this.query.status= '',
            this.getData()
        },
        // 获取后端接口数据
        getData() {
            let formdata = new FormData()
            formdata.append('page',1)
            formdata.append('limit',this.query.pageSize)
            formdata.append('cpy_id',this.id)
            formdata.append('company_id',this.companyid)
            formdata.append('company_name',this.query.company_name)
            formdata.append('company_address',this.query.company_address)
            formdata.append('legal_person',this.query.legal_person)
            formdata.append('identification',this.query.identification)
            formdata.append('contact',this.query.contact)
            formdata.append('credit_code',this.query. credit_code)
            formdata.append('address_type',this.query.address_type)
            formdata.append('status',this.query.status)
            formdata.append('start_app',this.query.start_time)
            formdata.append('end_app',this.query.end_time)
            post('/backstage/Chaptertrear/select',formdata).then(res => {
                if(res.code=200){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                    if (!this.tableData.length && this.query.pageIndex > 1) {
                        this.query.pageIndex--;
                        this.getData()
                    }
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        // 触发搜索按钮
        inputSearch(){
            let formdata = new FormData()
            formdata.append('page',1)
            formdata.append('limit',this.query.pageSize)
            formdata.append('cpy_id',this.id)
            formdata.append('company_id',this.companyid)
            formdata.append('company_name',this.query.company_name)
            formdata.append('company_address',this.query.company_address)
            formdata.append('legal_person',this.query.legal_person)
            formdata.append('identification',this.query.identification)
            formdata.append('contact',this.query.contact)
            formdata.append('credit_code',this.query. credit_code)
            formdata.append('address_type',this.query.address_type)
            formdata.append('status',this.query.status)
            formdata.append('start_app',this.query.start_time)
            formdata.append('end_app',this.query.end_time)
            post('/backstage/Chaptertrear/select',formdata).then(res => {
                if(res.code=200){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.iconPic{
    width: 30px;
    height: 30px;
    margin-left: 20px;
}

</style>

